export type RegistrationEmailCodeRequest = {
  email: string;
  displayName: string;
};

export function registrationIdentityChanged(
  request: RegistrationEmailCodeRequest | undefined,
  values: Record<string, string>,
) {
  if (!request) return false;
  return values.email !== request.email || values.display_name !== request.displayName;
}
